<template>
  <v-card elevation="0">
    <v-card-title>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        :label="$t('input.serch')"
        single-line
        outlined
        dense
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      :search="search"
      :headers="headers"
      :items="data"
      :single-expand="true"
      :expanded.sync="expanded"
      show-expand
      class="elevation-0"
    >
      <template v-slot:[`item.analys`]="{ item }">
        <v-btn text disabled color="primary"
          >Excel<v-icon>mdi-download</v-icon></v-btn
        >
      </template>
      <template v-slot:[`item.R`]="{ item }"> {{ item.R }} KM </template>
      <template v-slot:[`item.name`]="{ item }">
        <v-icon>mdi-store</v-icon>
        {{ item.name }}
      </template>
      <template v-slot:[`item.created_at`]="{ item }">
        {{ $subStringDate(item.created_at) }}
      </template>
      <template v-slot:[`item.city`]="{ item }">
        {{ getDest_city(item.city) }}
      </template>
      <template v-slot:[`item.action`]="{ item }">
        <v-btn
          @click="openAddModelDialog(item)"
          :disabled="!permission.updateBranch"
          color="green"
          dark
          small
        >
          new model
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          :disabled="!permission.updateBranch"
          icon
          small
          @click="updateItem(item)"
        >
          <v-icon class="mr-2"> mdi-pencil </v-icon>
        </v-btn>
      </template>
      <template v-slot:expanded-item="{ item }">
        <td :colspan="16">
          <v-row>
            <v-col cols="12" v-if="item.costModel.length > 0">
              <v-simple-table fixed-header dark>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <!-- <th class="text-center">#ID</th> -->
                      <th class="text-center">{{ $t("costModel.type") }}</th>
                      <th class="text-center">
                        {{ $t("costModel.costPerKilometer") }}
                      </th>
                      <th class="text-center">
                        {{ $t("costModel.costPerKg") }}
                      </th>
                      <th class="text-center">
                        {{ $t("costModel.expressServiceFee") }}
                      </th>
                      <th class="text-center">{{ $t("costModel.taxRate") }}</th>
                      <th class="text-center">
                        {{ $t("costModel.cityBaseCosts") }}
                      </th>
                      <th class="text-center">
                        {{ $t("costModel.currency") }}
                      </th>
                      <th class="text-center">{{ $t("costModel.weight") }}</th>
                      <th class="text-center">date</th>
                      <th class="text-center">action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="costModel in item.costModel" :key="costModel.id">
                      <!-- <td class="text-center">{{ costModel.id }}</td> -->
                      <td class="text-center">
                        {{ costModel.type }}-{{ costModel.weight }} kg
                      </td>
                      <td class="text-center">
                        {{ costModel.costPerKilometer }}
                        {{
                          $i18n.locale == "ar"
                            ? costModel.ar_currency
                            : costModel.en_currency
                        }}
                      </td>
                      <td class="text-center">
                        {{ costModel.costPerKg }}
                        {{
                          $i18n.locale == "ar"
                            ? costModel.ar_currency
                            : costModel.en_currency
                        }}
                      </td>
                      <td class="text-center">
                        {{ costModel.expressServiceFee }}
                        {{
                          $i18n.locale == "ar"
                            ? costModel.ar_currency
                            : costModel.en_currency
                        }}
                      </td>
                      <td class="text-center">{{ costModel.taxRate }}%</td>
                      <td class="text-center">
                        {{ costModel.cityBaseCosts }}
                        {{
                          $i18n.locale == "ar"
                            ? costModel.ar_currency
                            : costModel.en_currency
                        }}
                      </td>
                      <td class="text-center">
                        {{
                          $i18n.locale == "ar"
                            ? costModel.ar_currency
                            : costModel.en_currency
                        }}
                      </td>
                      <td class="text-center">{{ costModel.weight }} kg</td>
                      <td class="text-center">
                        {{ $subStringDate(costModel.created_at) }}
                      </td>
                      <td class="text-center">
                        <v-btn
                          color="red"
                          :disabled="!permission.updateBranch"
                          icon
                          small
                          @click="openDeleteDialog(costModel)"
                        >
                          {{ $t("btn.delete") }}
                        </v-btn>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
            <v-col cols="12" v-else>
              <v-card class="text-center py-16" elevation="0">
                <h3 class="gray-text ma-3">{{ $t("costModel.empty") }}</h3>
                <P class="gray-text">{{ $t("costModel.lable") }}</P>
                <v-chip
                  close-icon="mdi-plus"
                  color="primary"
                  @click="openAddModelDialog(item)"
                  label
                  v-if="permission.updateBranch"
                  outlined
                >
                  {{ $t("costModel.create") }}
                </v-chip>
              </v-card>
            </v-col>
          </v-row>
        </td>
      </template>
    </v-data-table>
    <Popup :dialog="dialog" :update="true" :data="item" @close-dialog="close" />
    <ConfirmDialog
      ref="ConfirmDialogDeleteModel"
      :title="$t('costModel.titleDelete')"
      :text="$t('costModel.delete')"
      :butttonText="$t('employees.deleteUser.btn')"
      color="error"
      @confirm-dialog="excuteConfirmDeleteModel"
    />
    <addModel
      :dialog="addModelDialog"
      :SRC="addModelData"
      @close-dialog="AddModelClose"
    />
  </v-card>
</template>

<script>
import Popup from "./Popup.vue";
import cl from "@/services/costModel.js";
import addModel from "./addModel.vue";
import { mapState, mapGetters } from "vuex";
import ConfirmDialog from "../../components/ConfirmDialog.vue";
export default {
  name: "Table",
  props: ["data"],

  data() {
    return {
      search: "",
      addModelDialog: false,
      addModelData: {},

      dialog: false,
      item: {},
      expanded: [],
      headers: [
        // {
        //   text: "#ID",
        //   align: "center",
        //   sortable: true,
        //   value: "id",
        // },
        // { text: this.$t("resorce.table.type"), value: "type" },
        { text: this.$t("resorce.table.name"), value: "name", width: "20%" },
        // { text: "Analys", value: "analys" },
        { text: this.$t("resorce.table.phone"), value: "number" },
        { text: "Round", value: "R" },
        { text: "city", value: "city" },
        { text: this.$t("resorce.table.address"), value: "address" },
        { text: this.$t("resorce.table.created_at"), value: "created_at" },
        { text: this.$t("resorce.table.edite"), value: "action" },
      ],
    };
  },
  components: { Popup, addModel, ConfirmDialog },
  computed: {
    ...mapState(["cities"]),
    ...mapState("users", ["permission"]),
    ...mapGetters("employees", ["employees"]),
  },
  created() {
    this.param = this.$router.history.current.params.id;
  },
  methods: {
    getDest_city(id) {
      try {
        let d = this.cities.find((element) => element.id == id);
        if (this.$i18n.locale == "ar") return d.ar_name;
        return d.en_name;
      } catch {
        return "-";
      }
    },
    updateItem(item) {
      this.item = item;
      this.dialog = true;
    },
    excuteConfirmDeleteModel(val) {
      const payload = {
        id: val.id,
      };

      cl.deleteOne(payload)
        .then((res) => {
          this.$store.dispatch(
            "api/handleServiceException",
            { e: res },
            { root: true }
          );
          this.$store.dispatch("getGeoPlace");
        })
        .catch((err) => {
          this.$store.dispatch(
            "api/handleServiceException",
            { e: err },
            { root: true }
          );
        });
    },
    close(val) {
      this.dialog = val;
      this.$store.dispatch("getGeoPlace");
    },
    openAddModelDialog(item) {
      this.addModelData = item;
      this.addModelDialog = true;
    },

    AddModelClose(val) {
      this.addModelDialog = val;
      this.$store.dispatch("getGeoPlace");
    },
    openDeleteDialog(item) {
      this.$refs.ConfirmDialogDeleteModel.openDialog(item);
    },
  },
};
</script>
